/**
 * Standard key values in various categories of key, with an explanation of what the key is typically used for.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
 */
var Key;
(function (Key) {
    // Modifier keys
    /**
     * The Alt (Alternative) key.
     */
    Key["ALT"] = "Alt";
    // Navigation keys
    /**
     * The down arrow key.
     */
    Key["ARROW_DOWN"] = "ArrowDown";
    /**
     * The left arrow key.
     */
    Key["ARROW_LEFT"] = "ArrowLeft";
    /**
     * The right arrow key.
     */
    Key["ARROW_RIGHT"] = "ArrowRight";
    /**
     * The up arrow key.
     */
    Key["ARROW_UP"] = "ArrowUp";
    /**
    * The Backspace key.
    */
    Key["BACKSPACE"] = "Backspace";
    /**
     * The Control, Ctrl, or Ctl key. Allows typing control characters.
     */
    Key["CONTROL"] = "Control";
    /**
     * The End key.
     * Moves to the end of content.
     */
    Key["END"] = "End";
    // Whitespace keys
    /**
     * The Enter or ↵ key (sometimes labeled Return).
     */
    Key["ENTER"] = "Enter";
    // UI keys
    /**
     * The Esc (Escape) key.
     * Typically used as an exit, cancel, or "escape this operation" button.
     * Historically, the Escape character was used to signal the start of a special control sequence of characters called an "escape sequence."
     */
    Key["ESCAPE"] = "Escape";
    /**
     * The Home key.
     * Moves to the start of content.
     */
    Key["HOME"] = "Home";
    /**
     * The Meta key.
     * Allows issuing special command inputs.
     * This is the Windows logo key, or the Command or ⌘ key on Mac keyboards.
     */
    Key["META"] = "Meta";
    /**
     * The Page Down (or PgDn) key.
     * Scrolls down or displays the next page of content.
     */
    Key["PAGE_DOWN"] = "PageDown";
    /**
     * The Page Up (or PgUp) key.
     * Scrolls up or displays the previous page of content.
     */
    Key["PAGE_UP"] = "PageUp";
    /**
     * The Shift key.
     * Modifies keystrokes to allow typing upper (or other) case letters, and to support typing punctuation and other special characters.
     */
    Key["SHIFT"] = "Shift";
    /**
     * The space key, Space Bar.
     */
    Key["SPACE"] = " ";
    /**
     * The Horizontal Tab key, Tab.
     */
    Key["TAB"] = "Tab";
    // Special values
    /**
     * The user agent wasn't able to map the event's virtual keycode to a specific key value.
     * This can happen due to hardware or software constraints, or because of constraints around the platform on which the user agent is running.
     */
    Key["UNIDENTIFIED"] = "Unidentified";
})(Key || (Key = {}));
export default Key;
//# sourceMappingURL=key.js.map